import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const TRIP_CHARACTERISTICS = [
  "solo",
  "friends",
  "couple",
  "family",
  "kids_friendly",
  "sporty",
  "adventure",
  "cultural",
  "relaxation",
  "exploration",
  "party",
] as const;

export type TripCharacteristic = typeof TRIP_CHARACTERISTICS[number];

interface TripCharacteristicsSelectProps {
  value: TripCharacteristic[];
  onChange: (value: TripCharacteristic[]) => void;
  disabled?: boolean;
}

export const TripCharacteristicsSelect = ({
  value,
  onChange,
  disabled = false,
}: TripCharacteristicsSelectProps) => {
  const { t } = useTranslation();

  const handleToggle = (characteristic: TripCharacteristic) => {
    if (disabled) return;
    
    if (value.includes(characteristic)) {
      onChange(value.filter((c) => c !== characteristic));
    } else {
      onChange([...value, characteristic]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {TRIP_CHARACTERISTICS.map((characteristic) => {
        const isSelected = value.includes(characteristic);
        return (
          <Badge
            key={characteristic}
            variant={isSelected ? "default" : "outline"}
            className={cn(
              "cursor-pointer transition-all select-none",
              isSelected
                ? "bg-primary text-primary-foreground hover:bg-primary/90"
                : "hover:bg-accent hover:text-accent-foreground",
              disabled && "opacity-50 cursor-not-allowed"
            )}
            onClick={() => handleToggle(characteristic)}
          >
            {t(`tripCharacteristics.${characteristic}`)}
          </Badge>
        );
      })}
    </div>
  );
};

export default TripCharacteristicsSelect;
